import { Button } from 'antd';
import React, { Dispatch, SetStateAction } from 'react';
import CentrifugalVersion from '../Engine/CentrifugalCompressors/CentrifugalVersion';
import { StyledEngineVersion, StyledEPModal, StyledVersionHistoryCentrifugalModal } from './styled';
import { EngineTab } from '@/constants';
import { t } from 'i18next';
import { getFormattedEngineVersion } from './VersionHistory.utils';

interface ViewVersionModalProps {
  isOpen: boolean;
  onClose: () => void;
  selectedVersion: { versionNumber: string; status: string };
  isCentrifugalOnly: boolean;
  activeTab: string;
  setActiveTab: Dispatch<SetStateAction<EngineTab>>;
  hasTriedToSubmit: boolean;
  setHasTriedToSubmit: (value: boolean) => void;
  confirmationModalInfo: {
    open: boolean;
    modalText: string;
    actionHandler;
  };
  setConfirmationModalInfo: (value) => void;
}

export const ViewSnapshotModal: React.FC<ViewVersionModalProps> = ({
  isOpen,
  onClose,
  selectedVersion,
  isCentrifugalOnly,
  activeTab,
  setActiveTab,
  hasTriedToSubmit,
  setHasTriedToSubmit,
  confirmationModalInfo,
  setConfirmationModalInfo,
}) => {
  const getModalTitle = () => {
    const formattedVersion = getFormattedEngineVersion(selectedVersion.versionNumber);
    const capitalizedStatus =
      (selectedVersion.status?.charAt(0)?.toUpperCase() || '') + (selectedVersion.status?.slice(1) || '');
    return `Version ${formattedVersion} | ${capitalizedStatus}`;
  };

  if (isCentrifugalOnly) {
    return (
      <StyledVersionHistoryCentrifugalModal
        open={isOpen}
        title={getModalTitle()}
        width={800}
        onCancel={onClose}
        destroyOnClose
        maskTransitionName=""
        transitionName=""
        keyboard={true}
        getContainer={() => document.body}
        footer={
          <Button type="primary" onClick={onClose}>
            {t('Close')}
          </Button>
        }
      >
        <CentrifugalVersion activeTab={activeTab} setActiveTab={setActiveTab} isHistory={true} />
      </StyledVersionHistoryCentrifugalModal>
    );
  }

  return (
    <StyledEPModal open={isOpen} onCancel={onClose} maskClosable={false} closable={true} footer={null}>
      <StyledEngineVersion
        setParentActiveTab={false}
        parentActiveTab={activeTab}
        hasTriedToSubmit={hasTriedToSubmit}
        setHasTriedToSubmit={setHasTriedToSubmit}
        confirmationModalInfo={confirmationModalInfo}
        setConfirmationModalInfo={setConfirmationModalInfo}
        isFooterHidden={true}
        fromVersionHistory={true}
        versionNumber={selectedVersion.versionNumber}
      />
    </StyledEPModal>
  );
};
